"use client";

import { c as _c } from "react/compiler-runtime";
import { useCallback, useEffect, useState } from "react";
export const PHONE_CODE_COOLDOWN_SECONDS = 30;
export function usePhoneCodeCooldown(t0) {
  const $ = _c(9);
  const initiallyActive = t0 === undefined ? false : t0;
  let t1;
  if ($[0] !== initiallyActive) {
    t1 = () => initiallyActive ? Date.now() + PHONE_CODE_COOLDOWN_SECONDS * 1000 : null;
    $[0] = initiallyActive;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [expiresAt, setExpiresAt] = useState(t1);
  const [secondsRemaining, setSecondsRemaining] = useState(initiallyActive ? PHONE_CODE_COOLDOWN_SECONDS : 0);
  let t2;
  let t3;
  if ($[2] !== expiresAt) {
    t2 = () => {
      if (expiresAt === null) {
        return;
      }
      const updateRemaining = () => {
        const remaining = Math.max(0, Math.ceil((expiresAt - Date.now()) / 1000));
        setSecondsRemaining(remaining);
        if (remaining === 0) {
          setExpiresAt(null);
        }
      };
      updateRemaining();
      const interval = window.setInterval(updateRemaining, 1000);
      document.addEventListener("visibilitychange", updateRemaining);
      return () => {
        window.clearInterval(interval);
        document.removeEventListener("visibilitychange", updateRemaining);
      };
    };
    t3 = [expiresAt];
    $[2] = expiresAt;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useEffect(t2, t3);
  let t4;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setExpiresAt(Date.now() + PHONE_CODE_COOLDOWN_SECONDS * 1000);
      setSecondsRemaining(PHONE_CODE_COOLDOWN_SECONDS);
    };
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const startCooldown = t4;
  const t5 = secondsRemaining > 0;
  let t6;
  if ($[6] !== secondsRemaining || $[7] !== t5) {
    t6 = {
      isCoolingDown: t5,
      secondsRemaining,
      startCooldown
    };
    $[6] = secondsRemaining;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
}